import React from 'react'
import { useLocation, Link } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

export const BottomNav: React.FC = () => {
    const { pathname } = useLocation()
    const { isAuthenticated } = useAuth()

    return (
        <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white/95 dark:bg-slate-900/95 backdrop-blur-md border-t border-slate-100 dark:border-white/5 h-16 pb-safe flex items-center justify-around px-2 sm:px-4 shadow-[0_-4px_20px_rgba(0,0,0,0.03)]">
            <NavItem
                to="/"
                icon="home"
                label="Home"
                isActive={pathname === '/'}
            />
            <NavItem
                to="/discover"
                icon="explore"
                label="Discover"
                isActive={pathname === '/discover' || pathname.startsWith('/course')}
            />
            <NavItem
                to={isAuthenticated ? "/dashboard" : "/login"}
                icon="auto_awesome"
                label="My Learning"
                isActive={pathname === '/dashboard'}
            />
            {/* HIDDEN — Refund feature disabled until admin review page is ready */}
            {/* {isAuthenticated && (
                <NavItem
                    to="/my/refunds"
                    icon="receipt_long"
                    label="Refund"
                    isActive={pathname === '/my/refunds'}
                />
            )} */}
            <NavItem
                to={isAuthenticated ? "/profile" : "/login"}
                icon="person"
                label="Profile"
                isActive={pathname === '/profile' || pathname === '/login'}
            />
        </div>
    )
}

interface NavItemProps {
    to: string
    icon: string
    label: string
    isActive: boolean
}

const NavItem: React.FC<NavItemProps> = ({ to, icon, label, isActive }) => {
    return (
        <Link
            to={to}
            className={`flex flex-col items-center justify-center flex-1 min-h-11 transition-all active:scale-90 ${isActive ? 'text-primary' : 'text-slate-400'
                }`}
        >
            <span className={`material-symbols-outlined text-[24px] mb-0.5 ${isActive ? 'filled' : ''}`}>
                {icon}
            </span>
            <span className="text-[11px] font-bold">
                {label}
            </span>
        </Link>
    )
}
